export const OPEN_UNASSIGN_FORM_MODAL = 'OPEN_UNASSIGN_FORM_MODAL';
export const CLOSE_UNASSIGN_FORM_MODAL = 'CLOSE_UNASSIGN_FORM_MODAL';
export const CLOSE_UNASSIGN_TO_USER_ERROR = 'CLOSE_UNASSIGN_TO_USER_ERROR';

function openUnassignFormModal(form) {
  return {
    type: OPEN_UNASSIGN_FORM_MODAL,
    isUnassignModalShown: true,
    form
  };
}

function closeUnassignFormModal() {
  return {
    type: CLOSE_UNASSIGN_FORM_MODAL,
    isUnassignModalShown: false,
  };
}

function closeUnassignToUserError() {
  return {
    type: CLOSE_UNASSIGN_TO_USER_ERROR,
    isUnassignModalShown: true
  };
}

export function showUnassignFormModal(form) {
  return (dispatch) => {
    dispatch(openUnassignFormModal(form));
  };
}

export function hideUnassignFormModal() {
  return (dispatch) => {
    dispatch(closeUnassignFormModal());
  };
}

export function hideUnssignToUserError() {
  return (dispatch) => {
    dispatch(closeUnassignToUserError());
  };
}
